const themeObserver = new MutationObserver(window.updateTranslationImage);

themeObserver.observe(document.documentElement, {
	attributes: true,
	childList: false,
	characterData: false,
	attributeFilter: ['data-theme']
}); // add attributeFilter

window.addEventListener('beforeunload', () => {
	themeObserver.disconnect();
});
